import { Pipe, PipeTransform } from '@angular/core';
import {Mask} from './interface/mask';

@Pipe({
  name: 'phone'
})
export class PhonePipe extends Mask implements PipeTransform {
  rebuildMaskAfterBackspace(text) {
    if (this.lastDeletedChar === '(' || this.lastDeletedChar === ')' || this.lastDeletedChar === ' ') {
      text = text.slice(0, -1) + this.lastDeletedChar + text.slice(-1);
      this.lastDeletedChar = null;
    }
    return text;
  }

  addEspecialCharToCorrectLengthText(text) {
    if (text.length === 1 && text !== '(') {
      text = '(' + text;
    } else if (text.length === 3) {
      text = text + ') ';
    }
    return text;
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/pipe/phone.pipe.ts